import React from 'react';
import { cn } from '@/lib/utils/cn';

interface LoadingScreenProps {
  progress: number; // 0 to 100
  message?: string;
  className?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  progress, 
  message = "Assets werden geladen...",
  className 
}) => {
  // Ensure progress is between 0 and 100
  const normalizedProgress = Math.min(100, Math.max(0, progress));

  return (
    <div className={cn(
      "fixed inset-0 z-50 flex flex-col items-center justify-center bg-gray-50",
      className
    )}>
      <div className="w-full max-w-md px-6 flex flex-col items-center gap-6">
        {/* Spinner or Logo could go here if needed, keeping it minimal as requested */}
        
        <div className="flex flex-col items-center gap-2 w-full">
          <div className="flex justify-between w-full text-sm text-gray-500 font-medium">
            <span>{message}</span>
            <span>{Math.round(normalizedProgress)}%</span>
          </div>
          
          {/* Progress Bar Container */}
          <div className="h-2 w-full bg-gray-200 rounded-full overflow-hidden">
            {/* Progress Bar Indicator */}
            <div 
              className="h-full bg-blue-600 transition-all duration-300 ease-out rounded-full"
              style={{ width: `${normalizedProgress}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
